// extracted by mini-css-extract-plugin
module.exports = {"root":"_1U-ES7H6O8-8K_77-fYAe7","icon":"_1Wd8iVxrbgQozMG8DeqFLE","iconWithSize":"_2_uK6UofhHzfIAHvi6akzN"};